document.addEventListener('DOMContentLoaded', function () {
  var menuButton = document.querySelector('[data-mobile-menu-button]');
  var nav = document.querySelector('[data-primary-nav]');
  if (menuButton && nav) {
    menuButton.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      menuButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});
